import TestApiConfig from './_config/test.api.config';
import TestApiRoutes from './_config/test.api.routes';
import TestApiComponent from './components';

const moduleName = 'app.testApi';

angular.module(moduleName, []).config(TestApiConfig).config(TestApiRoutes).component('testApi', TestApiComponent);

export default moduleName;
